import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Col2TemplateId, _ColAttributes2Title, _ColAttributes2Description, } from "@discovery/sonic-api-ng-optics";
import { ContestSteps, activeContestID, GiftingInquiry, } from "../contest-start/optics";
const ContestStartView = React.lazy(() => import("../../components/organisms/contest-start-view"));
const getProps = (data) => {
    const instructions = Fold.toArray(ContestSteps, data);
    const titleM = Fold.preview(Fold.compose(_ColAttributes2Title, M._Just()), data);
    const title = M.fromMaybe(titleM, "");
    const descriptionM = Fold.preview(Fold.compose(_ColAttributes2Description, M._Just()), data);
    const description = M.fromMaybe(descriptionM, "");
    const contestActiveIdM = Fold.preview(activeContestID, data);
    const contestActiveId = M.fromMaybe(contestActiveIdM, "");
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const templateId = M.fromMaybe(templateIdM, "");
    const gifitingCooperateIdM = Fold.preview(GiftingInquiry, data);
    const gifitingCooperateId = M.fromMaybe(gifitingCooperateIdM, "");
    return {
        instructions,
        title,
        description,
        contestActiveId,
        templateId,
        gifitingCooperateId,
    };
};
const ContestStart = ({ instructions, title, description, contestActiveId, templateId, gifitingCooperateId, environment, }) => {
    const [userM] = useGlobalState(_user);
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ContestStartView, { instructions: instructions, title: title, description: description, read: environment, contestActiveId: contestActiveId, userM: userM, templateId: templateId, isMailRedirect: true, mailId: gifitingCooperateId })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ContestStart);

